export function InsuranceBody({ insuranceProvider }) {
  if (!insuranceProvider) {
    return null
  }

  if (insuranceProvider === 'Teak') {
    return <div id="tg-placeholder" className="insurance-widget"></div>
  }

  return null
}

export function scrollToInsuranceWidget(insuranceProvider, offset = 100) {
  let elementId = null

  switch (insuranceProvider) {
    case 'Teak':
      elementId = 'tg-placeholder'
      break
  }

  if (!elementId) {
    return
  }

  const element = document.getElementById(elementId)

  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}
